import React from 'react';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { Bot } from '../../types';

interface BotCardProps {
  bot: Bot;
  onClick: () => void;
}

const BotCard: React.FC<BotCardProps> = ({ bot, onClick }) => {
  if (!bot) {
    return null;
  }

  // Special case for PromptVersus - direct link instead of onClick
  const isPromptVersus = bot.id === 'other-bots' && bot.subBots?.some(sb => sb.id === '95b30ce0-8108-44ff-bcad-31b71c9f2fcd');
  
  const displayPrice = bot.subBots && bot.subBots.length > 0
    ? `${bot.subBots.length} tools`
    : bot.price === null
    ? 'Dynamic pricing'
    : bot.price
    ? `$${bot.price.toFixed(2)} per use`
    : 'Free';

  return (
    <div className="bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300">
      <div className="p-4 sm:p-6">
        <div className="flex items-start justify-between">
          <div className="flex items-center space-x-3">
            <div className="flex-shrink-0">
              <div className="p-2 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-lg text-white">
                {bot.icon}
              </div>
            </div>
            <div>
              <h3 className="text-base sm:text-lg font-semibold text-gray-900">{bot.title}</h3>
              <p className="mt-1 text-sm text-gray-500 line-clamp-2">{bot.description}</p>
            </div>
          </div>
          <div className="text-sm text-gray-500 ml-4 whitespace-nowrap">
            {displayPrice}
          </div>
        </div>
        
        {isPromptVersus ? (
          <Link
            to="/promptversus"
            className="mt-4 w-full flex items-center justify-center space-x-2 px-4 py-2 bg-gradient-to-r from-cyan-500 to-blue-600 text-white rounded-lg hover:from-cyan-600 hover:to-blue-700 transition-colors duration-300"
          >
            <span>Launch PromptVersus</span>
            <ChevronRight className="h-4 w-4" />
          </Link>
        ) : (
          <button
            onClick={onClick}
            className="mt-4 w-full flex items-center justify-center space-x-2 px-4 py-2 bg-gradient-to-r from-cyan-500 to-blue-600 text-white rounded-lg hover:from-cyan-600 hover:to-blue-700 transition-colors duration-300"
          >
            <span>{bot.subBots && bot.subBots.length > 0 ? 'View Tools' : 'Launch Bot'}</span>
            <ChevronRight className="h-4 w-4" />
          </button>
        )}
      </div>
    </div>
  );
};

export default BotCard;